import { shuffle } from "seed-shuffle";

function sanitiseForSearch(str) {
	return str.toUpperCase().replace(/ /g, "").trim();
}

export function getDealers(state) {
	const { textSearch, selectedTags, shuffleSeed } = state.form;
	const sanitisedSearchString = sanitiseForSearch(textSearch);
	return shuffle(
		state.dealers.filter(({ name = "", title, ...data }) => {
			const isSearchMatch =
				sanitiseForSearch(name).includes(sanitisedSearchString) ||
				sanitiseForSearch(title).includes(sanitisedSearchString);
			const isTagMatch =
				selectedTags.length > 0
					? selectedTags.some((tag) => data[tag])
					: true;
			return isSearchMatch && isTagMatch;
		}),
		shuffleSeed
	);
}
